import { formatDateDisplay } from 'Data/format'
import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data
      .filter(
        question =>
          (question.category !== 'habits' && question.category !== 'general') ||
          question.type === 'boolean'
      )
      .map(question => {
        let answer = question.answers[0]
        let questionType = question?.type
        let response = answer?.value
        let alert = getAlertValue({
          answer_value: response,
          answer_alert: answer?.alert,
          alert_type: question?.alert_type,
          alert_conditions: question?.alert_conditions,
        })

        return {
          id: question.id,
          name: question.name,
          value: getValue({
            response,
            questionType,
            questionAlertType: question.alert_type,
            questionAlertConditions: question.alert_conditions,
            answerAlertValue: answer?.alert,
            answerAlert: alert,
          }),
          alert,
        }
      })
      .filter(alertDTO => alertDTO.alert === true)
  }, [data])
}

function getValue({ response, questionType, answerAlertValue, answerAlert }) {
  switch (questionType) {
    case 'boolean':
      return response ? 'Yes' : 'No'
    case 'number':
    case 'choice':
    case 'text':
      return response
    case 'date':
      return formatDateDisplay(response)
    case 'multichoice': {
      return Array.isArray(response)
        ? response
            .filter(item => {
              if (answerAlert === false) {
                return false
              }

              if (typeof answerAlertValue === 'boolean') {
                return answerAlertValue
              }

              if (Array.isArray(answerAlertValue)) {
                return answerAlertValue.includes(item)
              }

              return answerAlertValue === item
            })
            .join(', ')
        : response
    }
    default:
      return JSON.stringify(response)
  }
}

function getAlertValue({
  answer_alert,
  answer_value,
  alert_type,
  alert_conditions,
}) {
  // If the ring bell is on and the value is not a falsy value, the alert must be triggered
  if (
    answer_alert === true &&
    ![false, undefined, null, ''].includes(answer_value)
  ) {
    return true
  }

  // For medical conditions and substances, if a subset of ring bells are enabled,
  //
  if (Array.isArray(answer_alert)) {
    if (Array.isArray(answer_value)) {
      return answer_alert.some(item => answer_value.includes(item))
    }
    return answer_alert.includes(answer_value)
  }

  if (
    answer_alert === false ||
    answer_alert === null ||
    answer_alert === undefined ||
    alert_type === 'none'
  ) {
    return false
  } else if (alert_type === 'any') {
    if (typeof answer_value === 'boolean') {
      return answer_value
    } else if (typeof answer_value === 'string') {
      return !!answer_value.trim().length
    } else if (Array.isArray(answer_value)) {
      return !!answer_value.length
    }
    return true
  } else if (alert_type === 'values') {
    if (Array.isArray(alert_conditions)) {
      if (Array.isArray(answer_value)) {
        return alert_conditions.some(item => answer_value.includes(item))
      }
      return alert_conditions.includes(answer_value)
    }

    return alert_conditions === answer_value
  }

  return false
}
